module.exports = __webpack_public_path__ + "static/media/csv-file-sample.b423a12c.jpg";